/* ==========================================================================
  main.js
========================================================================== */

/**
 * Responsive videos
 */
fitvids();


// Get height of carousel poster img and offset carousel nav buttons
function carouselButtonOffset () {
var poster_img = document.querySelector('.movie-carousel__poster-img');
var poster_img_h = poster_img.offsetHeight;
var button_offset = poster_img_h /  2;
// console.log(button_offset);
var style = document.createElement('style');
style.innerHTML =
  '.carousel__button {' +
    'top:' +button_offset+'px;}';

// Get the first script tag
var ref = document.querySelector('script');

// Insert our new styles before the first script tag
ref.parentNode.insertBefore(style, ref);
}
function campaignButtonOffset () {
var carousel_img = document.querySelector('.campaign-carousel__poster-img');
var carousel_img_h = carousel_img.offsetHeight;
var carousel_button_offset = carousel_img_h /  2;
// console.log(carousel_button_offset);
var style = document.createElement('style');
style.innerHTML =
  '.campaign-carousel__button {' +
    'top:' +carousel_button_offset+
  'px;}';

// Get the first script tag
var ref = document.querySelector('script');

// Insert our new styles before the first script tag
ref.parentNode.insertBefore(style, ref);
}

if (document.querySelector('.movie-carousel__poster-img') ) {
  window.addEventListener('resize', carouselButtonOffset);
  window.addEventListener('load', carouselButtonOffset);
}
//if (document.querySelector('.campaign-carousel__poster-img') ) {
 // window.addEventListener('resize', campaignButtonOffset);
  //window.addEventListener('load', campaignButtonOffset);
//}
function readMore() {
  var btnText = document.getElementById("moreBtn");
  var movieEntry = document.getElementById("movieDescriptionEntry");
  var movieEntryFeather = document.getElementById("movieEntryFeather");

    movieEntry.classList.toggle('movie-description__read-more-open');
    movieEntryFeather.classList.toggle('movie-description__feather-close');
}
function readMoreInfo() {
  var btnTextInfo = document.getElementById("moreBtnInfo");
  var movieEntryInfo = document.getElementById("movieDescriptionEntryInfo");
  var movieEntryFeatherInfo = document.getElementById("movieEntryFeatherInfo");

    movieEntryInfo.classList.toggle('movie-description__read-more-open');
    movieEntryFeatherInfo.classList.toggle('movie-description__feather-close');
}

function readMoreInfoSidebar() {
  var movieMetaSidebar = document.getElementById("movieMetaSidebar");
  var movieMetaSidebarButton = document.getElementById("movieMetaSidebarButton");

  movieMetaSidebar.classList.toggle('moviemeta__read-more-open');
  movieMetaSidebarButton.classList.toggle('button__read-more-open');
}

const singleMovieDuoDetails = () => {
  const description1 = document.querySelector('.js-movie-description-synopsis');
  const description2 = document.querySelector('#movieMetaSidebar');
  const showMoreBtn = document.querySelector('.js-movie-description-duo-toggle');
  if (description1 && description2 && showMoreBtn) {
    showMoreBtn.addEventListener('click', function() {
      description1.classList.add('is-expanded');
      description2.classList.add('is-expanded');
      showMoreBtn.classList.remove('is-visible');
    });
  }
};
singleMovieDuoDetails();

const singleMovieDetails = () => {
  const description = document.querySelector('#movieMetaSidebar');
  const showMoreBtn = document.querySelector('.js-movie-sidebar-toggle');
  if (description && showMoreBtn) {
    showMoreBtn.addEventListener('click', function() {
      description.classList.add('is-expanded');
      showMoreBtn.classList.remove('is-visible');
    });
  }
};
singleMovieDetails();

// single movie description toggle
const singleMovieDescription = () => {
  const description = document.querySelector('.js-movie-description-synopsis');
  const showMoreBtn = document.querySelector('.js-movie-description-synopsis-toggle');
  if (description && showMoreBtn) {
    if (description.scrollHeight > description.clientHeight) {
      showMoreBtn.classList.add('is-visible');
    } else {
      description.classList.add('is-expanded');
      showMoreBtn.classList.remove('is-visible');
    }
    showMoreBtn.addEventListener('click', function() {
      description.classList.toggle('is-expanded');
    });
  }
}
singleMovieDescription();

// single movie icon explanations
const singleMovieIconExplanations = () => {
  const button = document.getElementById('br-showtime-icons-tooltip-toggle');
  const template = document.getElementById('br-showtime-icons-tooltip');
  if (button && template && tippy) {
    tippy('#br-showtime-icons-tooltip-toggle', {
      content: template.innerHTML,
      allowHTML: true,
      allowHTML: true,
      interactive: true,
      arrow: true,
      trigger: 'click mouseenter',
      theme: 'light',
      maxWidth: 'none',
      maxWidth: 520
    });
  }
};
singleMovieIconExplanations();


// get the modal by ID
const chooseLocationModal = () => {
  var myModal = document.querySelector('.js-choose-location-modal');
  if (myModal) {
    var page = document.querySelector('#page');
    var dialog = new A11yDialog(myModal, page);
    dialog.on('show', function (element, event) {
      var modal = element.querySelector('#modalLocation');
      if (modal) {
        modal.classList.add('show');
        modal.classList.add('active');
      }
    });
    dialog.on('hide', function (element, event) {
      var modal = element.querySelector('#modalLocation');
      if (modal) {
        modal.classList.remove('show');
        modal.classList.remove('active');
      }
    });
    dialog.show();
  }
};
chooseLocationModal();

// trailer modal
const singleMovieTrailer = () => {

  // setup args
  const modal   = document.querySelector('.js-trailer');
  const site    = document.querySelector('.js-page');
  const toggles = document.querySelectorAll('.js-trailer-toggle');

  // validate
  if (!modal || !site || !toggles.length) {
    return;
  }

  // setup a11y dialog
  const dialog = new A11yDialog(modal, site);

  // tasks to open menu visually
  const openMenu = () => {
   document.body.classList.add('is-active-modal');
  };

  // tasks to close menu visually
  const closeMenu = () => {

    document.body.classList.add('is-closing-modal');
    setTimeout(() => {
      document.body.classList.remove('is-active-modal');
      document.body.classList.remove('is-closing-modal');
     }, 200);

  };

  // hooks
  dialog.on('show', (element, event) => {
    openMenu();
  });
  dialog.on('hide', (element, event) => {
    closeMenu();
  });

  // toggle click
  const handleToggle = (e) => {
    if ( document.body.classList.contains('is-active-modal')) {
       dialog.hide();
    } else {
      dialog.show();
    }
  };

  // click outside menu to close
  // site.addEventListener('click', (e) => {
  //   if ((e.target.classList && !e.target.classList.contains('js-trailer-toggle')) && document.body.classList.contains('is-active-modal')) {
  //     dialog.hide();
  //   }
  // });

  for (let i = 0; i < toggles.length; i++) {
    toggles[i].addEventListener('click', handleToggle, false);
  }

};
singleMovieTrailer();


/**
 * Toggle more showtimes
 */
document.addEventListener('click', function(e){
  if (e.target && e.target.classList && e.target.classList.contains('js-more-items-wrap')) {
    var btn = e.target;
    var hide_wrapper = btn.parentNode.parentNode.querySelector('.showtimes-hidden');
    console.log(btn);
    console.log(hide_wrapper);
    if (hide_wrapper) {
      btn.remove();
      while (hide_wrapper.firstChild) hide_wrapper.parentNode.insertBefore(hide_wrapper.firstChild, hide_wrapper);
      hide_wrapper.parentNode.removeChild(hide_wrapper);
    }
  }
});

/**
 * Profile quiclinks
 */
var quicklinks = document.querySelectorAll('.js-profile-quicklink');
if (quicklinks.length) {
  for (var i = 0; i < quicklinks.length; i++) {
    quicklinks[i].addEventListener('click', function(e){
      e.preventDefault();
      var target = e.currentTarget.getAttribute('data-target');
      var el = document.getElementById(target);
      if (el) {
        el.click();
        el.scrollIntoView({behavior: 'smooth'});
      }
    });
  }
}


// now you know why we don't need a show option
/*
    var select = document.getElementById('location');
    var select_choices = new Choices(select,{
    });

    var select_choose = document.getElementById('choose_location');
    if (select_choose) {
      var select_choices_choose = new Choices(select_choose,{
      choices: [
        {
          value: '1',
          label: 'Hämeenlinna',
          id: 1
        },
        {
          value: '9',
          label: 'Hyvinkää',
          id: 2,
        },
        {
          value: '7',
          label: 'Kajaani',
          id: 3,
        },
        {
          value: '4',
          label: 'Pietarsaari',
          id: 4,
        },
        {
          value: '10',
          label: 'Porvoo',
          id: 5,
        },
        {
          value: '8',
          label: 'Riihimäki',
          id: 6,
        },
        {
          value: '2',
          label: 'Rovaniemi',
          id: 7,
        },
        {
          value: '6',
          label: 'Seinäjoki',
          id: 8,
        },
        {
          value: '3',
          label: 'Tornio',
          id: 9,
        },
        {
          value: '5',
          label: 'Vaasa',
          id: 10,
        },
      ],
      placeholder: true,
      placeholderValue: 'Valitse teatteri',
      searchPlaceholderValue: 'Hae teatteria',
      renderChoiceLimit: -1,
      searchEnabled: true,
      searchChoices: true,
      searchFloor: 1,
      searchResultLimit: 4,
      position: 'auto',
      resetScrollPosition: true,
      shouldSort: false,
      shouldSortItems: false,
    });
    }
if (document.querySelector('#locationMobile') ) {

var select_mobile = document.getElementById('locationMobile');
    var select_choices_mobile = new Choices(select_mobile,{
    renderChoiceLimit: -1,
    maxItemCount: -1,
    addItems: true,
    addItemFilterFn: null,
    removeItems: true,
    removeItemButton: false,
    editItems: false,
    duplicateItemsAllowed: true,
    paste: true,
    searchEnabled: true,
    searchChoices: true,
    searchFloor: 1,
    searchResultLimit: 4,
    searchFields: ['label', 'value'],
    position: 'top',
    resetScrollPosition: true,
    shouldSort: true,
    shouldSortItems: false,
    prependValue: null,
    appendValue: null,
    renderSelectedChoices: 'auto',
    });

}
*/
